import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { VideoSubmissionDto } from "../../../models/video-review/dto/video-submission.dto";

export const GET_VIDEO_SUBMISSION_QUERY_KEY = (id: string) => ['video-submission', id];

export const useGetVideoSubmission = (id: string) => {
    const client = useApiClient();

    return useQuery({
        queryKey: GET_VIDEO_SUBMISSION_QUERY_KEY(id),
        queryFn: () => client.fetchApi<VideoSubmissionDto, {}>({
            endpoint: `video-submissions/${id}`,
            method: 'GET',
        }),
        enabled: !!id,
        staleTime: 10_000,
    });
};
